<template>
  <v-card>
    <v-form>
      <v-container grid-list-lg>
        <v-layout wrap>
          <v-flex xs12 class="flex-container-space-between vertical-center-container">
            <div class="headline">Backup Database?</div>
          </v-flex>
          <v-flex xs12>
            <div
              class="subheading grey--text"
            >This will download the database file to your computer. Users should stop entering data during the backup.</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat color="grey darken-1" @click="close()">Close</v-btn>
      <v-btn flat :color="primaryNeutral" :loading="loading" @click="backupDB">
        <v-icon left>cloud_download</v-icon>Backup
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Api from "@/services/api.js";

export default {
  data() {
    return {
      loading: false
    };
  },
  methods: {
    backupDB() {
      this.loading = true;
      //window.open('localhost:3000/api/migrations/backupDB');
      Api.get("migrations/backupDB", { responseType: "blob" })
        .then(result => {
          const url = window.URL.createObjectURL(new Blob([result.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "backup.zip");
          document.body.appendChild(link);
          link.click();
          //console.log(result.data.message);
          this.close();
          this.snack({
            text: "Database backup has been saved to your system!",
            color: "green"
          });
          this.loading = false;
        })
        .catch(err => {
          this.snack({
            text: "An error occured backing up the database.",
            color: "red"
          });
          this.loading = false;
        });
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style>
</style>
